import { useState, useEffect, useCallback } from 'react';
import { Channel } from 'core/models/channel';

export function useRecordingToggle(channels: Channel[]): [boolean | null, () => void] {
    const [recordables, setRecordables] = useState<Channel[]>([]);
    useEffect(() => {
        setRecordables(channels.filter(channel => channel.isRecordable));
    }, [channels, setRecordables]);

    const [requestedRecordingState, setIsRecording] = useState<boolean>();
    useEffect(() => {
        if (requestedRecordingState === undefined) return;

        recordables.forEach(channel => channel.enableRecording(requestedRecordingState));
    }, [recordables, requestedRecordingState]);

    const onRecordingClick = useCallback(() => {
        setIsRecording(isRecording => !isRecording);
    }, [setIsRecording]);

    return [recordables.length > 0 ? (requestedRecordingState ?? false) : null, onRecordingClick];
}
